module.exports = __webpack_public_path__ + "img/huankuanchenggong.dc55ed9c.png";